import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
import history from '../../utils/history';
import _ from 'lodash';

import { CHANNELS } from '../constants/channelsTypes';

export const setChannels = (channels) => ({ type: CHANNELS, payload: channels });

/**
 * sample channel:
 * {
 *   id: 1,
 *   name: 'JCrew',
 *   handle: 'jcrew',
 *   logo_path: 'https://cymbio-3-local.s3.amazonaws.com/Retailers/MacysMelissa/MacysMelissa_Logo_300x300.png',
 *   integration_type: 'mirakl'
 * }
 **/
export const getChannels = () => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    params.append('limit', 200);
    const response = await api(`/channels?` + params.toString());

    if (response.data) {
      dispatch(setChannels(response.data));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getChannelRedirectUri = (channel) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  const url = `/suppliers/${supplierId}/channels/oauth`;
  const params = new URLSearchParams({ channel_id: channel.id });
  const additionalUrlQueryParams = _.get(channel, 'additionalUrlQueryParams', {});

  if (!_.isEmpty(additionalUrlQueryParams)) {
    for (const key in additionalUrlQueryParams) {
      params.append(key, additionalUrlQueryParams[key]);
    }
  }

  try {
    const response = await api(url + '?' + params.toString());
    if (response.data) {
      window.location.href = response.data.authorization_url;
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

const redirectToSupplierRetailersPage = (supplierId) => {
  setTimeout(() => {
    history.push(`/suppliers/${supplierId}/retailers`);
  }, 2000);
};

export const postChannelOauth = (params) => async (dispatch, getState) => {
  let supplierId;

  try {
    const state = JSON.parse(params.state);
    supplierId = state.supplier_id;
  } catch (error) {
    supplierId = getState().role.supplierId;
  }

  try {
    const response = await api.post(`/suppliers/${supplierId}/channels/oauth`, params);

    if (response.data) {
      const retailerId = response.data.retailer_id;
      const retailerName = response.data.retailer_name;
      dispatch(alertSuccess(`You have successfully connected ${retailerName}`));
      history.push(`/suppliers/${supplierId}/retailers/${retailerId}`);
    } else {
      dispatch(alertError('Error'));
      redirectToSupplierRetailersPage(supplierId);
    }
  } catch (error) {
    dispatch(alertError(error.response));
    redirectToSupplierRetailersPage(supplierId);
  }
};
